module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_ReadAll') &&
    _vm.globals.currentUserRole == 3
  ) ? _c('div', [_c('ConfirmationDialog', {
    attrs: {
      "dialogId": 'openSurveyConfirmationModal',
      "confirmationTitle": _vm.lang.SL0018,
      "showDialog": _vm.showConfirmationDialog,
      "yesButtonDisable": !_vm.languageChoosen || (!_vm.locationChoosen && _vm.hasLocationDummy) || true,
      "yesButtonText": _vm.lang.SL0019,
      "noButtonText": _vm.lang.SL0020
    },
    on: {
      "dialogClosed": _vm.onConfirmationDialogClosed,
      "onYesConfirmation": _vm.onYesConfirmation
    }
  }, [_c('div', {
    attrs: {
      "id": "confirmation-table"
    }
  }, [(_vm.selectedSurveyInstance) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0000))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedSurveyInstanceId))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0025))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyTitle) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0016))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.LocationName) + "\n            ")])]), _vm._v(" "), (_vm.hasLocationDummy) ? _c('tr', [_c('td', [_vm._v("Select Location")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control m-0",
    attrs: {
      "id": "select-location",
      "placeholder": _vm.placeholderSelectLocation,
      "allowClear": true
    },
    on: {
      "change": _vm.chooseLocation
    },
    model: {
      value: (_vm.selectedLocation),
      callback: function($$v) {
        _vm.selectedLocation = $$v
      },
      expression: "selectedLocation"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.possibleLocations), function(location) {
    return _c('option', {
      key: location.LocationGuid,
      domProps: {
        "value": location.LocationGuid
      }
    }, [_vm._v("\n                    (" + _vm._s(location.LocationStoreId) + ")\n                    " + _vm._s(location.LocationAddress) + "\n                  ")])
  })], 2)], 1)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0007))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.LocationAddress) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0013))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.ScenarioName) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0014))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedSurveyInstance.WaveName))])]), _vm._v(" "), (_vm.selectedSurveyInstance.SurveyInstanceInfo) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0039))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyInstanceInfo) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0041))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyInstanceSince) + "\n            ")])]), _vm._v(" "), _c('tr', {
    class: {
      'text-red': _vm.selectedSurveyInstance.SurveyInstanceIsExpired,
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.lang.SL0038))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyInstanceUntil) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0015))]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedSurveyInstance.LocationAdditionalInfo)
    }
  })]), _vm._v(" "), (
    _vm.selectedSurveyInstance.SurveyInstanceTotalPayment &&
    !_vm.globals.isSurveyCodeUser
  ) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0037))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(
    _vm.selectedSurveyInstance.SurveyInstanceTotalPayment,
    "EUR"
  )) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.selectedSurveyInstance.SurveyInstanceShopperSubmittedAt) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0032))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyInstanceShopperSubmittedAt) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.selectedSurveyInstance.BriefingDownload) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0035))]), _vm._v(" "), _c('td', _vm._l((_vm.selectedSurveyInstance.BriefingDownload), function(bd) {
    return _c('a', {
      staticStyle: {
        "padding-left": "5px"
      },
      on: {
        "click": function($event) {
          return _vm.downloadBriefing(bd.Guid, bd.FileName)
        }
      }
    }, [_vm._v(_vm._s(bd.FileName))])
  }), 0)]) : _vm._e(), _vm._v(" "), (
    _vm.selectedSurveyInstance.SurveyDownload &&
    _vm.selectedSurveyInstance.SurveyDownload.Guid
  ) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0036))]), _vm._v(" "), _c('td', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.downloadSurveyDownload(
          _vm.selectedSurveyInstance.SurveyDownload.Guid,
          _vm.selectedSurveyInstance.SurveyDownload.FileName
        )
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedSurveyInstance.SurveyDownload.FileName))])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0001))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "selectLanguage"
    },
    on: {
      "change": function($event) {
        return _vm.chooseSurveyLanguage()
      }
    },
    model: {
      value: (_vm.selectedSurveyInstanceAnswerLanguage),
      callback: function($$v) {
        _vm.selectedSurveyInstanceAnswerLanguage = $$v
      },
      expression: "selectedSurveyInstanceAnswerLanguage"
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0002))]), _vm._v(" "), _vm._l((_vm.surveyInstanceAnswerLanguageList), function(language) {
    return _c('option', {
      key: language.LocaleCode,
      domProps: {
        "value": language.LocaleCode,
        "selected": _vm.selectedSurveyInstanceAnswerLanguage ===
          language.LocaleCode
      }
    }, [_vm._v("\n                    " + _vm._s(language.LocaleName) + "\n                  ")])
  })], 2)], 1)])])])]) : _vm._e()])]), _vm._v(" "), (!_vm.showSurvey) ? _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "survey-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getAllSurveyInstancesAnswers()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SL0009) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read') ||
        _vm.selectedSurveyInstanceId < 0
    },
    on: {
      "click": function($event) {
        return _vm.openSelectedSurveyInstance()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("open_in_browser")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SL0010) + "\n          ")] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.SL0012
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), (_vm.isSmallScreen) ? _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceStatusId),
      expression: "filters.SurveyInstanceStatusId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "SurveyInstanceStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.doFiltering()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "hidden": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0033))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0034))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0028))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "110"
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0029))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "120"
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0030))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "130"
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0031))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-xs-12 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0021))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0022))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == _vm.numberOfPages()
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0023))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "checksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredSurveyListData.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0040))])], 1)], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "survey"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "the-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceStatusId')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0003) + "\n                "), (_vm.showSortArrow('SurveyInstanceStatusId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceStatusId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyTitle')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.isSmallScreen ? _vm.lang.SL0025 : _vm.lang.SL0004) + "\n                "), (_vm.showSortArrow('SurveyTitle', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyTitle', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceId')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0005) + "\n                "), (_vm.showSortArrow('SurveyInstanceId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('LocationName')
      }
    }
  }, [_vm._v(_vm._s(_vm.isSmallScreen ? _vm.lang.SL0024 : _vm.lang.SL0016) + "\n                "), (_vm.showSortArrow('LocationName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('LocationAddress')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0007) + "\n                "), (_vm.showSortArrow('LocationAddress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationAddress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('ScenarioName')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0013) + "\n                "), (_vm.showSortArrow('ScenarioName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ScenarioName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('WaveName')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0014) + "\n                "), (_vm.showSortArrow('WaveName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('WaveName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0039) + "\n                "), (_vm.showSortArrow('SurveyInstanceInfo', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceInfo', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('LocationAdditionalInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.isSmallScreen ? _vm.lang.SL0026 : _vm.lang.SL0015) + "\n                "), (_vm.showSortArrow('LocationAdditionalInfo', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationAdditionalInfo', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen || _vm.globals.isSurveyCodeUser
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceTotalPayment')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0037) + "\n                "), (_vm.showSortArrow('SurveyInstanceTotalPayment', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceTotalPayment', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceProgress')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0008) + "\n                "), (_vm.showSortArrow('SurveyInstanceProgress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceProgress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceShopperSubmittedAt')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0032) + "\n                "), (
    _vm.showSortArrow('SurveyInstanceShopperSubmittedAt', true)
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.showSortArrow('SurveyInstanceShopperSubmittedAt', false)
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceUntil')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0038) + "\n                "), (_vm.showSortArrow('SurveyInstanceUntil', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceUntil', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), (_vm.globals.isLargeScreen()) ? _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "surveyListStatusFilterContainer"
    }
  }, [_c('select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "surveyListStatusFilterSelect",
      "allowClear": true,
      "placeholder": _vm.lang.SL0027
    },
    on: {
      "change": function($event) {
        return _vm.doFiltering()
      },
      "open": function($event) {
        return _vm.surveyListStatusFilterSelectOpened()
      }
    },
    model: {
      value: (_vm.filters.SurveyInstanceStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "SurveyInstanceStatusId", $$v)
      },
      expression: "filters.SurveyInstanceStatusId"
    }
  }, [_c('option'), _vm._v(" "), _c('option', {
    domProps: {
      "value": 100
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0028))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 110
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0029))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 120
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0030))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 130
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0031))])])], 1)]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyTitle),
      expression: "filters.SurveyTitle"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyTitle)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyTitle", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceId),
      expression: "filters.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceId)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceId", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.LocationName),
      expression: "filters.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.LocationName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "LocationName", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.LocationAddress),
      expression: "filters.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.LocationAddress)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "LocationAddress", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.ScenarioName),
      expression: "filters.ScenarioName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.ScenarioName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "ScenarioName", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.WaveName),
      expression: "filters.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.WaveName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "WaveName", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceInfo),
      expression: "filters.SurveyInstanceInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceInfo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceInfo", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.LocationAdditionalInfo),
      expression: "filters.LocationAdditionalInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.LocationAdditionalInfo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "LocationAdditionalInfo", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.globals.isSurveyCodeUser),
      expression: "!globals.isSurveyCodeUser"
    }],
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceTotalPayment),
      expression: "filters.SurveyInstanceTotalPayment"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceTotalPayment)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceTotalPayment", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceProgress),
      expression: "filters.SurveyInstanceProgress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceProgress)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceProgress", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceShopperSubmittedAt),
      expression: "filters.SurveyInstanceShopperSubmittedAt"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceShopperSubmittedAt)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceShopperSubmittedAt", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceUntil),
      expression: "filters.SurveyInstanceUntil"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceUntil)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceUntil", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.surveysOnCurrentPage), function(survey) {
    return _c('tr', {
      key: survey.SurveyInstanceId,
      staticClass: "text-center",
      class: {
        info: survey.SurveyInstanceId === _vm.selectedSurveyInstanceId,
        'text-red': survey.SurveyInstanceIsExpired,
        'text-grey': survey.SurveyInstanceIsInactive,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedSurveyInstanceId = survey.SurveyInstanceId),
          (_vm.selectedSurveyInstance = survey)
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed(
            'LoopOp_SurveyInstancesAnswers_Read'
          ) || _vm.openSelectedSurveyInstance()
        }
      }
    }, [_c('td', {
      attrs: {
        "id": "materialIconCell"
      }
    }, [(survey.SurveyInstanceStatusId == 100) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("add_circle_outline")]) : _vm._e(), _vm._v(" "), (survey.SurveyInstanceStatusId == 110) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("autorenew")]) : _vm._e(), _vm._v(" "), (survey.SurveyInstanceStatusId == 120) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("check_circle")]) : _vm._e(), _vm._v(" "), (survey.SurveyInstanceStatusId == 130) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("help_outline")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "word-break"
    }, [_vm._v(_vm._s(survey.SurveyTitle))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceId))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(survey.LocationName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(survey.LocationAddress))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(survey.ScenarioName))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.WaveName))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceInfo))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', {
      staticClass: "word-break"
    }, [_vm._v("\n                " + _vm._s(_vm.globals.truncateString(
      _vm.globals.getMarkupText(survey.LocationAdditionalInfo),
      40
    )))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen || _vm.globals.isSurveyCodeUser
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceTotalPayment ?
      _vm.globals.getCurrencyString(
        survey.SurveyInstanceTotalPayment,
        "EUR"
      ) :
      ""))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceProgress) + "%")])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceShopperSubmittedAt))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceUntil))])])])
  }), 0)])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e702954","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyView/SurveyList.vue
// module id = 420
// module chunks = 1 2